import { Id, IMetadata } from '@/shared/types/builtInTypes'
import { RawLocation } from 'vue-router'

export interface INotification extends IMetadata {
  id: Id
  subject: string
  body: string
  status: NotificationStatus
  linkTo?: string
}

export type NotificationType = 'request' | 'orderItem'

export enum NotificationStatus {
  READ = 'read',
  UNREAD = 'delivered',
  ALL = 'all'
}

// Navigation mapping for linkTo values
export const notificationLinkMapping: Record<
  string,
  (id: string) => RawLocation
> = {
  order: (id: string) => ({
    name: 'preview-order',
    params: { id }
  }),
  return_order: (id: string) => ({
    name: 'preview-returnedOrder',
    params: { id }
  }),
  request: (id: string) => ({
    name: 'preview-sellerRequest',
    params: { id }
  }),
  order_item: (id: string) => ({
    name: 'preview-orderItems',
    params: { id }
  })
}

// Helper function to get navigation route from linkTo string
export function getNavigationFromLinkTo(linkTo: string): RawLocation | null {
  const [type, id] = linkTo.split('/')

  if (!type || !id) {
    return null
  }

  const mappingFunction = notificationLinkMapping[type]

  if (!mappingFunction) {
    console.warn(`Unknown notification link type: ${type}`)
    return null
  }

  return mappingFunction(id)
}
